import axios from "axios";
import React, { Component, useState, useEffect, useContext, useRef } from "react";
import queryString from "query-string";
import AdModal from '../../../../app_structure/AdModal';
import { Cookies } from "../../../../index.js";
import { Helmet } from "react-helmet";
import AdSense from 'react-adsense';
import BitmediaAd from '../../../mission/bitmedia';
import { FaRegClock } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../../../AppContext";
import { ClipLoader } from "react-spinners";
import { MyContext } from '../../urlshorten_system/index'; // hoặc './Indexok'
import LazyGeeTest from "../../../../app_structure/LazyGeeTest.jsx";

function Capdo12(props) {
    const { show_check_done, setshow_check_done, caption, setcaption } = useContext(MyContext);

    const [isLoading, setIsLoading] = useState(false);
    const [note, setnote] = useState("Please wait a moment 😊");
    const [disabledbutton, setdisabledbutton] = useState(true);
    const [count, setCount] = useState(17);
    // Gọi hàm alert_error
    const [geetoken, setgeetoken] = useState('');

    const [dataCaptcha, setdataCaptcha] = useState(false);
    const [showCaptcha, setShowCaptcha] = useState(false);
    const [lienket, setLienket] = useState("");
    const recaptchaRef = React.createRef();
    const captchaRef = useRef(null);
    const [nutxuly, setnutxuly] = useState("");
    const [buttonTextjop, setbuttonTextjop] = useState("");
    const [loading, setLoading] = useState(false);
    const [api_key, setapi_key] = useState("");
    const [lienketok, setlienketok] = useState("");
    const [code3, setcode3] = useState("");
    const navigate = useNavigate();
    function laydulieu() { }
    function check() { }
    function handleSubmit(value) {
        const hustmediavipro = Cookies.get('hustmediavipro');
        setnutxuly(1);
        setbuttonTextjop("Please wait a moment 😊");
        const capdovuotlink = Cookies.get('capdovuotlink');
        const code_item = Cookies.get("code_item");
        Cookies.set('capdovuotlink', '', { expires: 1 / 12 });

        const apidata = {
            geetoken: value,
            capdook: capdovuotlink,
            lienket: hustmediavipro,
            code_item: code_item
        };
        const headers = {
            'Content-Type': 'application/json'
        }
        axios.post('https://hust.media/link/load_mode/mode_ads_end.php', apidata, headers)
            .then(response => handleChange(response.data))
            .catch(error => {
                alert_error(error);
            });
    }
    function handleChange(info) {
        if (info.status == 1) {
            setnutxuly(0);
            alert_success('Xác thực thành công');
            setbuttonTextjop("Hust Media cảm ơn bạn đã ghé thăm");
            setnote('Hust Media cảm ơn bạn đã ghé thăm');
            setIsLoading(false);
        } else if (info.status == 0) {
            alert_error(info.message);
            setIsLoading(false);
            setnote('Đã xảy ra lỗi tải lại trang nhé');
        } else {
            alert_error('Đã xảy ra lỗi tải lại trang nhé');
            setIsLoading(false);
            setnote('Đã xảy ra lỗi tải lại trang nhé');
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }

    }

    const handleGeetestSuccess = (value) => {
        setgeetoken(value);
        console.log(value);
        const maxLength = 200;
        console.log(value.captcha_output.length);

        if (value.captcha_output.length > maxLength) {
            setdataCaptcha(value);
            setbuttonTextjop('Ấn đây để lấy link');
            setnote('Đang lấy liên kết');
            setIsLoading(true);
            handleSubmit(value);
        } else {
            setbuttonTextjop("Đã xảy ra lỗi tải lại trang nhé");
        }
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCount((prevCount) => prevCount - 1);
        }, 1000);

        if (count == 0) {
            setbuttonTextjop('Xác nhận bạn không phải người máy');
            setdisabledbutton(false);
            clearInterval(intervalId);
            // xử lý khi đếm ngược hoàn thành
        }

        return () => clearInterval(intervalId);
    }, [count]);
    useEffect(() => {
        setIsLoading(true);
        setbuttonTextjop('Đang tải dữ liệu Please wait a moment 😊');
        setTimeout(() => {
            setdisabledbutton(false);
            setbuttonTextjop('Xác nhận bạn không phải người máy');
            setnote('Vui lòng xác thực bạn không phải người máy');
            setIsLoading(false);
            setShowCaptcha(true);
        }, 2700);
        check();
    }, []);
    const [showAd, setShowAd] = useState(true);
    const handleCloseAd = () => {
        setShowAd(false);
    };
    return (
        <div>


            <div id="M882924ScriptRootC1520508"></div>
            <Helmet>
                <script data-cfasync="false" type="text/javascript" src="//usjbwvtqwv.com/bultykh/ipp24/7/bazinga/1979702" async></script>
                {/* <script async="async" data-cfasync="false" src="//ophoacit.com/1?z=5904788"></script> */}
                <script data-cfasync="false" type="text/javascript" src="//hhbypdoecp.com/lv/esnk/1978451/code.js" async id="__clb-1978451"></script>
                <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>
            </Helmet>
            <div>
                {isLoading ? (
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Đang tải captcha</span>
                    </div>
                ) : (
                    <></>
                )}
                {count >= 1 ? (

                    <div className=" items-center">
                        <Helmet>
                            <script src="https://www.vipads.live/vn/E63DE5E9-83A2-727-33-C9472C085EBB.blpha"></script>
                        </Helmet>
                        <span className="flex items-center justify-center">
                            <div className="spinner-border mr-2" role="status"></div>
                            <div className="border-2 border-pink-500 rounded-full p-2 w-12 h-12 text-center text-2xl font-bold">{count}</div>
                        </span>
                        <AdModal isOpen={showAd} onClose={handleCloseAd} />
                    </div>
                ) : (<>
                    {showCaptcha && (
                        <div className="flex justify-center items-center ">
                            <LazyGeeTest
                                captchaRef={captchaRef}
                                geetoken={geetoken}
                                handleGeetestSuccess={handleGeetestSuccess}
                                captchaId={'2367e368fef71fff0bf119f963985786'}
                                containerId={'fecfead39968d5617f9a50a9bde75c48'} // Optional
                            >
                                {!geetoken ? (
                                    <button
                                        type="button"
                                        className="mt-1 rounded-md border border-gray-400 px-3 py-2 text-sm"
                                    >
                                        Xác nhận bạn không phải người máy
                                    </button>
                                ) : null}
                            </LazyGeeTest>
                        </div>
                    )}
                    <div className="mb-0 text-pink-600 flex justify-center items-center">{note}</div>
                </>
                )}
            </div>
            {count <= 7 && (
                <div className="cards">
                    <AdSense.Google
                        client="ca-pub-4574266110812955"
                        slot="1627514116"
                        style={{ display: 'block' }}
                        format='horizontal'
                        responsive='false'
                    />
                </div>
            )}
            <BitmediaAd />

            {window.location.href.includes('hust.media') && (
                <div className="mt-2 flex flex-wrap  justify-center">
                    <iframe
                        data-aa="2271984"
                        src="//ad.a-ads.com/2271984?size=320x50"
                        frameBorder="0"
                        scrolling="no"
                        allowFullScreen
                        style={{
                            width: '320px',
                            height: '50px',
                            border: 0,
                            padding: 0,
                            overflow: 'hidden',
                            backgroundColor: 'transparent'
                        }}
                    ></iframe>
                    <iframe
                        data-aa="2271984"
                        src="//ad.a-ads.com/2271984?size=320x50"
                        frameBorder="0"
                        scrolling="no"
                        allowFullScreen
                        style={{
                            width: '320px',
                            height: '50px',
                            border: 0,
                            padding: 0,
                            overflow: 'hidden',
                            backgroundColor: 'transparent'
                        }}
                    ></iframe>
                    <iframe
                        data-aa="2271984"
                        src="//ad.a-ads.com/2271984?size=320x50"
                        frameBorder="0"
                        scrolling="no"
                        allowFullScreen
                        style={{
                            width: '320px',
                            height: '50px',
                            border: 0,
                            padding: 0,
                            overflow: 'hidden',
                            backgroundColor: 'transparent'
                        }}
                    ></iframe></div>)}

        </div>
    );
}

export default Capdo12;
